<template>
  
  <div class="ui segment">

    <div :id="_uid" class="ui fluid accordion">  

      <h4 :id="_uid + '_title'" class="ui dividing header title">
        <i class="dropdown icon"></i>Filtros
      </h4>

      <div class="content active">
        <div class="ui form">
          <div class="fields">
            <div class="three wide field">
              <label class="form-label">Data <span class="red text">*</span></label>
              <date-picker ref="datePicker" @onChange="onChangeDate" />
            </div>
            <div class="four wide field">
              <label class="form-label">Financeiro</label>
              <select-dropdown ref="statusDropdown" @onChange="onChangeStatus" />
            </div>
            <div class="five wide field">
              <label class="form-label">Clínica</label>
              <input v-model="filter.customerName">
            </div>
            <div class="five wide field">
              <label class="form-label">Colaborador</label>
              <input v-model="filter.userName">
            </div>
          </div>          
        </div>  
        <button class="ui blue button m-t-10" :class="{ disabled: !filter.startDate }" @click="onApply()">
          <i class="check icon"></i> Aplicar
        </button>
      </div>

    </div>

  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import CertService from "@/services/cert-service"
  import { DatePicker, SelectDropdown } from "@/components"

  export default {
    
    name: "DailyCertsFilter",

    data() {
      return {
        filter: {},
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
    },

    mounted() {

      $(`#${this._uid}`).accordion()

      if (this.$store.state.pages.filters.financialDailyCerts) {
        this.filter = this.$cloneObject(this.$store.state.pages.filters.financialDailyCerts)
        this.$refs.datePicker.setDate(this.filter.startDate)
        $(`#${this._uid}_title`).click()
      }        

      this.loadStatusDropdown()
    },

    methods: {

      loadStatusDropdown() {
        
        let statusList = [{ id: "*", value: '<i class="asterisk icon"></i> Todos' }]        
        const FINANCIAL_STATUS = CertService.FINANCIAL_STATUS

        for (let prop in FINANCIAL_STATUS) {
          if (FINANCIAL_STATUS.hasOwnProperty(prop)) {
            statusList.push({
              id: prop,
              value: `<i class="${FINANCIAL_STATUS[prop].icon}"></i> ` + FINANCIAL_STATUS[prop].description
            })
          }
        }

        this.$refs.statusDropdown.setValues(statusList, this.filter.financialStatus)
      },

      onChangeDate(date) {
        
        const fdate = moment(date).format("YYYY-MM-DD")

        this.$set(this.filter, "startDate", fdate)
        this.$set(this.filter, "endDate", fdate)
      },

      onChangeStatus(id) {
        this.$set(this.filter, "financialStatus", id)
      },

      updateFilter(filter) {

        this.filter = this.$cloneObject(filter)

        this.$refs.datePicker.setDate(this.filter.startDate)
        this.$refs.statusDropdown.setSelected(this.filter.financialStatus)
      },

      onApply() {

        this.updateStore()

        $(`#${this._uid}_title`).click()

        this.$emit("onApply", this.$cloneObject(this.filter))
      },

      updateStore() {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.financialDailyCerts = this.$cloneObject(this.filter)

        this.$store.commit("pages/setFilters", filters)
      },
    },
  }

</script>